import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["align", "alignContent", "type", "direction", "wrap", "gutter", "className", "style", "children"],
  _excluded2 = ["type", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Grid, Col, Row } from 'antd';
import classNames from 'classnames';
import React from 'react';

/**
 * NOTE:
 * Ant Design 4.0.0+ grid gutters are somewhat... problematic. Here you'll see
 * some attempts to customize their behavior.
 */

const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const breakpointsReversed = [...breakpoints].reverse();

/**
 * Utility to make gutters work the same way as xs/sm/md... etc work on Col,
 * e.g. No need to repeat values between xs and xl. The last defined value will
 * be used.
 */
const reduceGutter = gutter => {
  if (typeof gutter === 'object') {
    const adjustedGutter = breakpoints.reduce((acc, cur, index, arr) => {
      const value = gutter[cur];
      if (typeof value === 'undefined') {
        return _objectSpread(_objectSpread({}, acc), {}, {
          [cur]: acc[arr[index - 1]]
        });
      }
      return _objectSpread(_objectSpread({}, acc), {}, {
        [cur]: value
      });
    }, {
      xs: gutter.xs
    });
    return adjustedGutter;
  }
  return gutter;
};
const reduceGutters = gutters => {
  if (Array.isArray(gutters)) {
    return [reduceGutter(gutters[0]), reduceGutter(gutters[1])];
  }
  return gutters;
};
const getActiveGutters = _ref => {
  let {
    reducedGutters,
    screens
  } = _ref;
  if (!reducedGutters) {
    return [0, 0];
  }
  if (typeof reducedGutters === 'number') {
    return [reducedGutters, 0];
  }
  const activeBreakpoints = Object.entries(screens).map(_ref2 => {
    let [breakpoint, active] = _ref2;
    return active ? breakpoint : null;
  }).filter(Boolean);
  if (typeof reducedGutters === 'object' && !Array.isArray(reducedGutters)) {
    const horizontalGutter = reducedGutters[breakpointsReversed.find(bp => activeBreakpoints.includes(bp))];
    return [horizontalGutter, 0];
  }
  const [horizontalGutter, verticalGutter] = reducedGutters;
  const activeHorizontalGutter = (() => {
    if (typeof horizontalGutter === 'number') {
      return horizontalGutter;
    }
    return horizontalGutter[breakpointsReversed.find(bp => activeBreakpoints.includes(bp))] || 0;
  })();
  const activeVerticalGutter = (() => {
    if (typeof verticalGutter === 'number') {
      return verticalGutter;
    }
    return verticalGutter[breakpointsReversed.find(bp => activeBreakpoints.includes(bp))] || 0;
  })();
  return [activeHorizontalGutter, activeVerticalGutter];
};
const CUSTOM_ALIGN_OPTIONS = ['stretch'];
const CUSTOM_WRAP_OPTIONS = ['reverse'];
export const DixuRow = _ref3 => {
  let {
      align,
      alignContent,
      type,
      direction,
      wrap,
      gutter,
      className,
      style,
      children
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded);
  const classes = classNames('dixu-row', className, {
    [`dixu-row--align-${align}`]: CUSTOM_ALIGN_OPTIONS.includes(align),
    [`dixu-row--align-content-${alignContent}`]: alignContent,
    [`dixu-row--type-${type}`]: type,
    [`dixu-row--direction-${direction}`]: direction,
    [`dixu-row--wrap-${wrap}`]: CUSTOM_WRAP_OPTIONS.includes(wrap)
  });
  const reducedGutters = reduceGutters(gutter);
  const screens = Grid.useBreakpoint();
  const activeGutters = getActiveGutters({
    reducedGutters,
    screens
  });
  return /*#__PURE__*/React.createElement(Row, _objectSpread({
    className: classes,
    wrap: CUSTOM_WRAP_OPTIONS.includes(wrap) ? undefined : wrap,
    gutter: activeGutters,
    style: _objectSpread({}, style),
    align: CUSTOM_ALIGN_OPTIONS.includes(align) ? undefined : align
  }, rest), children);
};
DixuRow.defaultProps = {
  align: undefined,
  alignContent: undefined,
  type: undefined,
  direction: undefined,
  wrap: undefined
};
export const DixuCol = _ref4 => {
  let {
      type,
      className,
      children
    } = _ref4,
    rest = _objectWithoutProperties(_ref4, _excluded2);
  const classes = classNames('dixu-col', className, {
    [`dixu-col--type-${type}`]: type
  });
  return /*#__PURE__*/React.createElement(Col, _objectSpread({
    className: classes
  }, rest), children);
};
DixuCol.defaultProps = {
  type: undefined
};